var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': "product-item",
        tag: 'li',
        'data-id': nb.bind('productId'),
        $html: {
            tag: 'a',
            target: '_blank',
            href: nb.bind('productHref'),
            $html: [{
                tag:'i',
                'class':['iconfont',nb.bind('icon')]
            },{
                'class':'cls-name',
                $text: nb.bind('name')
            }]
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/ClsItem.js
// module id = 42
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32